import script from "./pageTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./pageTeam.vue?vue&type=script&setup=true&lang=js"

import "./pageTeam.vue?vue&type=style&index=0&id=bf4ba456&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4ba456"]])

export default __exports__